var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-checkbox",
    _vm._g(
      _vm._b(
        {
          staticStyle: { "margin-top": "-5px" },
          attrs: { value: _vm.value, "hide-details": "" },
          on: { change: (val) => _vm.$emit("input", val) },
        },
        "v-checkbox",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }